import { Button } from "@src/components/atoms";
import { useAuthContext } from "@src/context/authContext";
import { AppUtils } from "@src/utils";

const RoleSwitcher = () => {
  const {
    hasAdminRole,
    hasManagerRole,
    hasOperatorRole,
    selectUserProfile,
    user,
  } = useAuthContext();
  const isDemo = AppUtils.isMockedApp;
  const isShipping = user?.metadata?.industry === "shipping";

  return (
    <div className="bg-white rounded-2xl mx-8 md:mx-0 md:w-md overflow-clip">
      <div className="px-8 py-4 flex flex-col items-center">
        <div className="text-2xl text-primary-500 font-bold my-3">
          Choose Profile
        </div>
        <div className="text-sm mb-3 pb-4 text-center">
          You have multiple roles assigned to your account. Please choose one to
          proceed.
        </div>
        <div>
          {hasAdminRole && (
            <Button onClick={() => selectUserProfile("ADMINISTRATOR")}>
              ADMINISTRATOR
            </Button>
          )}
          {hasManagerRole && (
            <Button onClick={() => selectUserProfile("FUEL_MANAGER")}>
              FUEL MANAGER
            </Button>
          )}
          {hasOperatorRole && (
            <Button onClick={() => selectUserProfile("CAPTAIN")}>
              {!!isDemo && !!isShipping ? "SEAFARER" : "CAPTAIN"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleSwitcher;
